export const userColumns = [
  {
    accessor: 'firstName',
    Header: 'Nombre',
    headerProps: { title: 'Ordenar por nombre' }
  },
  {
    accessor: 'lastName',
    Header: 'Apellido',
    headerProps: { title: 'Ordenar por apellido' }
  },
  {
    accessor: 'email',
    Header: 'Email',
    headerProps: { title: 'Ordenar por email' }
  },
  {
    accessor: 'dni',
    Header: 'DNI',
    headerProps: { title: 'Ordenar por DNI' }
  },
  {
    accessor: 'status',
    Header: 'Estado actual',
    headerProps: { title: 'Ordenar por estado' }
  },
  {
    accessor: 'actions',
    Header: 'Acciones',
    headerProps: { style: { cursor: 'default' }, title: null, onClick: null }
  }
];
